{
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "user_id": "User ID",
    "total_earned": "Total Earned:",
    "balance": "Balance",
    "total_earnings": "Total Earnings",
    "total_copy": "Total in CopyTrade",
    "affiliate_title": "Affiliate Link",
    "affiliate_description": "Share this exclusive link with others and earn commissions whenever someone registers and operates through it. This is a great opportunity to increase your earnings easily and automatically!",
    "copy": "Copy",
    "vault_in_progress": "Vault in progress",
    "vault_help": "Active Vault investments",
    "bot_in_progress": "Zord in progress",
    "bot_help": "Active Zord investments",
    "finished_stakes": "Finished Stakes",
    "running_stakes": "Running Stakes",
    "finished_copy": "Finished CopyTrades",
    "running_copy": "Active CopyTrades",
    "finished_stakes_help": "Number of completed stakes.",
    "running_stakes_help": "Stakes in progress.",
    "finished_copy_help": "Completed copytrades.",
    "running_copy_help": "Active copytrades.",
    "latest_operations": "Latest Operations",
    "view_all": "View all",
    "date": "Date",
    "pair": "Symbol",
    "profit": "Profit",
    "latest_stakes": "Latest 4 Stakes",
    "latest_copies": "Latest 4 Copies",
    "amount": "Amount",
    "pl": "P/L",
    "status": "Status",
    "complete": "Complete",
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo",
    "nova_stake": "New Stake",
    "sacar": "Withdraw",
    "trazer_corretora": "Pull from Broker",
    "saldo": "Balance",
    "sair": "Logout",
    "historico": "History"
  },
  "sidebar": {
    "dashboard": "Home",
    "stake": "Stake",
    "history": "History",
    "network": "Network",
    "copytrade": "Copytrade",
    "operations": "Operations",
    "primezord": "Primezord",
    "primevault": "PrimeVault",
    "saldo_disponivel": "Available Balance",
    "voltar_corretora": "Back to Broker",
    "tempo_sessao": "Session Time Remaining"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  },
  "stakes": {
    "start_date": "Start Date",
    "duration": "Duration",
    "status": "Status",
    "status_active": "In progress",
    "status_Finalizada": "Finished",
    "amount": "Stake Amount",
    "profit": "Profit Generated",
    "progress": "Progress",
    "cancel_button": "Cancel Stake",
    "modal_title": "Cancel Stake",
    "modal_description": "Are you sure you want to cancel the stake worth",
    "modal_close": "Close",
    "modal_confirm": "Confirm Cancellation"
  },
  "history": {
    "copytrade": "CopyTrade",
    "stakes": "Stakes",
    "operacoes": "Operations",
    "saques": "Withdrawals",
    "bonus": "Bonus",
    "residual": "Residual",
    "primezord": "Primezord",
    "start_date": "Start Date",
    "vault": "Vault",
    "end_date": "End Date",
    "status": {
      "expired": "Expired",
      "canceled": "Canceled",
      "complete": "Complete",
      "in_progress": "In Progress",
      "finished": "Finished"
    },
    "columns": {
      "date": "Date",
      "value": "Value",
      "progress": "Progress",
      "status": "Status",
      "invested": "Invested Amount",
      "profit": "Profit Generated",
      "pair": "Pair",
      "payout": "Payout",
      "description": "Description",
      "source": "Source",
      "reference": "Reference",
      "total": "Total",
      "percentage": "Percentage",
      "notes": "Notes"
    }
  },
  "network": {
    "email": "Email",
    "phone": "Phone",
    "balance": "Balance",
    "loading": "Loading network..."
  },
  "copytrade": {
    "title": "Active CopyTrades",
    "create": "Create New CopyTrade",
    "empty": "No CopyTrades currently active.",
    "start_date": "Start Date",
    "closed_notice": "New copytrade registrations are currently closed.",
    "status": "Status",
    "status_active": "In progress",
    "status_expired": "Expired",
    "invested": "Invested Capital",
    "profit": "Profit Generated",
    "modal_title": "Create New CopyTrade",
    "modal_description": "Select the amount you wish to invest.",
    "investment_amount": "Investment Amount",
    "select": "Select...",
    "start_copy": "Start CopyTrade",
    "cancel": "Cancel",
    "alert_select_amount": "Please select an amount"
  },
  "operations": {
    "start_date": "Start Date",
    "end_date": "End Date",
    "asset": "Asset",
    "all": "All",
    "loading": "Loading operations...",
    "columns": {
      "date": "Date",
      "asset": "Asset",
      "payout": "Payout"
    }
  },
  "profile": {
    "title": "Update Profile",
    "avatarTitle": "Profile Picture",
    "selectImage": "Select an image.",
    "saveAvatar": "Save Avatar",
    "personalInfo": "Personal Information",
    "phone": "Phone",
    "birth": "Birthdate",
    "saveData": "Save Data",
    "changePassword": "Change Password",
    "newPassword": "New Password",
    "confirmPassword": "Confirm Password",
    "savePassword": "Save Password",
    "updatedSuccess": "Successfully updated.",
    "updatedError": "Error updating.",
    "passwordMismatch": "Passwords do not match."
  },
  "primezord": {
    "title": "Primezord",
    "deposit": "Deposit",
    "withdraw": "Withdraw",
    "invest": "Investment",
    "modal_deposit": "Make a Deposit",
    "modal_withdraw": "Request Withdrawal",
    "modal_invest": "New Investment",
    "modal_subtitle": "Select the desired amount.",
    "modal_value": "Amount",
    "modal_confirm": "Confirm",
    "modal_cancel": "Cancel",
    "balance_label": "Zord Balance",
    "withdraw_balance_label": "Available for Withdrawal",
    "taxa": "Dollar Rate",
    "table_date": "Date",
    "table_value": "Amount",
    "table_status": "Status",
    "loading": "Loading investments...",
    "blocked_balance_label": "Blocked",
    "alert_value": "Select an amount"
  },
  "primevault": {
    "title": "PrimeVault",
    "create": "New Vault",
    "empty": "You haven't created any PrimeVault yet.",
    "start_date": "Start Date",
    "status": "Status",
    "status_active": "Active",
    "status_expired": "Expired",
    "invested": "Invested Amount",
    "profit": "Accumulated Profit",
    "progress": "Progress",
    "modal_title": "New PrimeVault",
    "modal_description": "Choose the amount to invest and enter a promo code if you have one.",
    "investment_amount": "Investment Amount",
    "promocode": "Promo Code (optional)",
    "select": "Select a value",
    "start": "Create Vault",
    "cancel": "Cancel",
    "alert_select_amount": "Please select an amount to invest.",
    "filter_date": "Filter by start date",
    "filter_min": "Invested amount (min)",
    "filter_max": "Invested amount (max)",
    "order_progress": "Order by progress",
    "none": "No sorting",
    "highest": "Highest progress",
    "lowest": "Lowest progress",
    "filter_status": "Filter by status",
    "all_status": "All statuses",
    "reinvest": "Reinvest",
    "reinvest_now": "Confirm Reinvestment",
    "reinvest_title": "Reinvest Available Balance",
    "available_balance": "Available balance",
    "reinvest_description": "Use your available balance to reinvest in a new vault.",
    "reinvest_confirm": "Confirm Reinvestment"
  }
}
